export default "__VITE_ASSET__CCqyoTG9__"